<template>
    <div ref="moreSailDate" class="moreSailDate">
        <div class="moreSailDate-container">
            <div class="moreSailDate-top">
                <div class="moreSailDate-title js-returnDetailBtn" >
                    <p>选择航线日期</p>
                    <div class="moreSailDate-returnButton close-popup" @click="goBack">
                        <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
                    </div>
                </div>
            </div>
            <div>
                <div class="calendar">
                    <!-- <div class="calendar-close" style="display:none;"><img src="@Href("/images/Mobile/cruise/closed.png")" /></div> -->
                    <div class="js-smartScroll scroll-container calendar__title-wrapper">
                        <div class="calendar__title" ref="calendarTitle ">
                            <div v-for="(month, i) in totalMonth" :key="i" ref="calendarTitleText" 
                            :class="{ active: isTitleActive(month)}"
                            @click="onMonthClick(month)"
                            class="title title__text">{{getMonthTitle(month)}}</div>
                        </div>
                    </div>
                    
                    <div class="calendar--header">
                        <div class="calendar--header__weekday calendar--cell vacation">日</div>
                        <div class="calendar--header__weekday calendar--cell">一</div>
                        <div class="calendar--header__weekday calendar--cell">二</div>
                        <div class="calendar--header__weekday calendar--cell">三</div>
                        <div class="calendar--header__weekday calendar--cell">四</div>
                        <div class="calendar--header__weekday calendar--cell">五</div>
                        <div class="calendar--header__weekday calendar--cell vacation">六</div>
                        
                    </div>
                    
                    <div class="calendar--body">
                        <div v-for="(week, i) in getMonthCalendar()" :key="i" class="calendar--body__line">
                            <div v-for="(day, j) in week" :key="j" class="line day calendar--cell" 
                            @click="onCalendarItemClick(day.shipCode, day.code, day.price, day.isNrpPrice, day.isRow)"
                            :class="{ active: day.code == selectedCruise.sailDate, shipEvent: hasCalendarEvent(day.code)}">
                                <div v-if="day.name > 0" :class="{ 'cell-active': day.name > 0 && day.price && day.price.length > 0}">
                                    <div class="dateCell">
                                        <div class="bg"></div>
                                        <span class="date">{{day.name}}</span>
                                    </div>
                                </div>
                                <div v-if="day.name > 0 && day.price && day.price.length > 0" class="priceCell">
                                    <span class="small-font">￥</span>
                                    <span class="price">{{day.price}}</span>
                                </div>
                            </div>
                        </div>
                        
                        <!-- <div class="both"></div>
                        <div class="confirmation-date f-dn">
                            <div class="confirmation-button">确认日期</div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        
        <div class="moreSailDate-bottom" id="moreSailDate-bottom-hp" v-if="this.selectedCruise.price && this.selectedCruise.price.length > 0">
            <div class="moreSailDate-bottom-l">
                <span class="" v-if="this.selectedCruise.isNrpPrice">早订特惠价</span>
                <span class="" v-if="!this.selectedCruise.isNrpPrice">优惠价</span>
                ¥<span class="moreSailDate-bottom-price">{{this.selectedCruise.price}}</span>/人起
            </div>
            <div class="moreSailDate-bottom-r js-orderCruiseBtn" @click="onGoToDetailClick()">
                立即预订
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import _ from 'lodash'
export default {
    name: "CruiseCalendar",
    data () {
        return {
            cruiseLists: [],
            selectedMonth: '',
            selectedCruise: {
                shipCode: '',
                sailDate: '',
                isNrpPrice: false,
                price: '',
                isRow: false
            },
            routeCode: "",
            sailDate: "",
            shipCode: ""
        }
    },
    async mounted() {
        this.$store.commit('SET_PAGE_TITLE', '')
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: true, isHideFooter: true})
        const query = this.$router.currentRoute.query
        if (!query || !query.routeCode || query.routeCode.length == 0) {
            return
        }
        this.routeCode = query.routeCode
        this.shipCode = query.shipCode
        this.sailDate = query.sailDate
        let isRow = query.isRow
        const { success, data, errMsg } = await api.cruise.getCruiseByRoute(this.routeCode,isRow)
        if (!success) {
            console.error(errMsg)
        }
        let shipEvent = []
        for (var i = 0; i < data.length; i++) {
            var date = data[i].sailDate;
            var newDate = new Date(date);
            var year = newDate.getFullYear();
            var month = newDate.getMonth() + 1 < 10 ? "0" + (newDate.getMonth() + 1) : newDate.getMonth() + 1;
            var day = newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
            data[i].sailDate = year + "-" + month + "-" + day;

            shipEvent.push({});
            shipEvent[i].price = data[i].netAmount;
            shipEvent[i].packagePrice = data[i].packagePrice;
            shipEvent[i].date = year + "-" + month + "-" + day;
            shipEvent[i].shipCode = data[i].shipCode;
            shipEvent[i].isNrpPrice = data[i].isNrpPrice;
            shipEvent[i].isRow = data[i].isRow;
        }
        this.cruiseLists = shipEvent
        if (this.sailDate && this.sailDate.length > 7) {
            this.selectedMonth = this.sailDate.substring(0, 7)
        }

        const cruises = this.cruiseLists.filter(r=>r.date == this.sailDate && r.shipCode == this.shipCode)
        if (cruises.length > 0) {
            this.selectedCruise = {
                shipCode: cruises[0].shipCode,
                sailDate: cruises[0].date,
                price: cruises[0].price.toFixed(0),
                isNrpPrice: cruises[0].isNrpPrice,
                isRow: cruises[0].isRow
            }
        }
        this.$refs.moreSailDate.style.height = window.innerHeight + 'px'
        window.scrollTo(0, 0)
    },
    beforeDestroy() {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
    },
    methods: {
        onMonthClick (date) {
            this.selectedMonth = date
        },
        getMonthTitle(month) {
            const date = new Date(month + '-01')
            const today = new Date()
            if (today.getFullYear() == date.getFullYear()) {
                return (date.getMonth() + 1) + "月"
            }
            const title = date.getFullYear() + "年" + (date.getMonth() + 1) + "月"
            return title
        },
        getMonth(index) {
            if (!this.initDateTime) return null
            let date = new Date(this.initDateTime.getTime());
            date = new Date(date.setMonth(date.getMonth() + index))
            return date
        },
        getMonthCalendar () {
            // 根据select month，组装日历数据
            // 日历数组按照周来排列数组，每周又是一个数组，放一周7天的日期
            let calendar = []
            let beginDate = new Date(this.selectedMonth + '-01')
            let nextMonth = new Date(this.selectedMonth + '-01')
            nextMonth = new Date(nextMonth.setMonth(nextMonth.getMonth() + 1))
            let index = 0
            while(beginDate.getTime() < nextMonth.getTime() && index <= 6) {
                let week = []
                for (let i = 0; i < 7; i++) {
                    let day = i
                    if (day == 0) day = 7
                    if ((index == 0 && beginDate.getDay() > (i)) || beginDate.getTime() >= nextMonth.getTime()) {
                        week.push({
                            code: '',
                            name: 0,
                            isNrpPrice: false,
                            day: day,
                            price: '',
                            shipCode: '',
                            isRow: false
                        })
                    } else {
                        const date = `${beginDate.getFullYear()}-${this.pad(beginDate.getMonth() + 1)}-${this.pad(beginDate.getDate())}`
                        let price = ''
                        let isNrpPrice = false
                        let shipCode = ''
                        let cruises = this.cruiseLists.filter(r=>r.date == date)
                        let isRow = false
                        if (cruises.length > 0) {
                            cruises = _.orderBy(cruises, 'price')
                            price = cruises[0].price.toFixed('0')
                            isNrpPrice = cruises[0].isNrpPrice
                            shipCode = cruises[0].shipCode
                            isRow = cruises[0].isRow
                        }

                        week.push({
                            code: date,
                            name: beginDate.getDate(),
                            price: price,
                            isNrpPrice: isNrpPrice,
                            day: day,
                            shipCode: shipCode,
                            isRow: isRow
                        })
                        beginDate = new Date(beginDate.setDate(beginDate.getDate()+ 1))
                    }
                }
                calendar.push(week)
                index++
            }
            return calendar
        },
        onCalendarItemClick (shipCode, sailDate, price, isNrpPrice, isRow) {
            if (!shipCode || shipCode.length == 0 || !sailDate || sailDate.length == 0 || !price || price.length == 0) return
            this.selectedCruise = {
                shipCode,
                sailDate,
                price,
                isNrpPrice,
                isRow
            }
        },
        onGoToDetailClick () {
            if (!this.selectedCruise.shipCode || this.selectedCruise.shipCode.length == 0 
            || !this.selectedCruise.sailDate || this.selectedCruise.sailDate.length == 0 ) {
                return
            } 
            else {
                this.$router.push({ name: 'CruiseDetail'
                , query: { shipCode: this.selectedCruise.shipCode, sailDate: this.selectedCruise.sailDate } })
            }
        },
        isTitleActive(month) {
            return month == this.selectedMonth
        },
        hasCalendarEvent (date) {
            return this.cruiseLists.some(r=>r.date == date)
        },
        goBack() {
            this.$router.go(-1)
        },
        pad (num) {
            return num < 10 ? "0" + num : num;
        }
    },
    computed: {
        initDate() {
            if (this.cruiseLists.length > 0) {
                const cruises = _.orderBy(this.cruiseLists, 'date')
                return cruises[0].date.substring(0, 7)
            }
            return ""
        },
        initDateTime() {
            if (this.cruiseLists.length > 0) {
                return new Date(this.cruiseLists[0].date)
            }
            return null
        },
        endDate() {
            if (this.cruiseLists.length > 0) {
                const cruises = _.orderBy(this.cruiseLists, 'date')
                return cruises[cruises.length - 1].date.substring(0, 7)
            }
            return ""
        },
        endDateTime() {
            if (this.cruiseLists.length > 0) {
                return new Date(this.cruiseLists[this.cruiseLists.length - 1].date)
            }
            return null
        },
        totalMonth() {
            let months = []
            this.cruiseLists.forEach((cruise) => {
                const date = cruise.date.substring(0, 7)
                if (!months.some(r=>r==date)) {
                    months.push(date)
                }
            })
            months = _.orderBy(months)
            return months
        }
    },
    watch: {

    }
}
</script>

<style scoped>
.f-dn {
    display: none;
}
button:focus {
    outline: none;
}

.main-content {
    margin-top: 0px;
}

.calendar {
    width: 100%;
    /*margin-top: 34px;*/
    background-color: #fff;
    border-radius: 3px;
    overflow: hidden;
}

.calendar--header {
    background: #fff;
}

.calendar .calendar--header .calendar--header__weekday.vacation {
    color: #FF5055;
}

.calendar .leftArrow {
    width: 0;
    height: 0;
    right: 24px;
    border-top: 8px solid white !important;
    border-right: 8px solid #cdcdcd !important;
    border-bottom: 8px solid white !important;
}

.calendar .rightArrow {
    width: 0;
    height: 0;
    left: 24px;
    border-top: 8px solid white !important;
    border-left: 8px solid #cdcdcd !important;
    border-bottom: 8px solid white !important;
}

.calendar .leftArrow.active {
    border-right-color: #fbc300 !important;
}

.calendar .rightArrow.active {
    border-left-color: #fbc300 !important;
    background: #fff;
}

.calendar__title-wrapper {
    overflow-x: scroll;
    overflow-y: hidden;
    height: 45px;
    border-bottom: 1px solid rgba(204, 204, 204, 0.7);
}

.calendar ::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
}

.calendar__title .title .active {
    background: none;
}

.calendar .calendar__title {
    overflow-x: scroll;
    overflow-y: hidden;
    /* border-bottom: 1px solid rgba(204, 204, 204, 0.7); */
    height: 45px;
    display: flex;
}

    .calendar .calendar__title .title {
        position: relative;
        vertical-align: middle;
        font-size: 14px;
        color: #666;
        width: auto;
        line-height: 40px;
        margin: 0 12.5px;
        /* padding: 11px 0px; */
        display: flex;
    }

    .calendar .calendar__title .title.active {
        color: #4A90E2;
        border-bottom: 1px solid #4A90E2;
    }

    .calendar .calendar__title .title:first-child{
        margin-left: 17px;
    }

    .calendar .calendar__title .title:last-child {
        padding-right: 20px;
    }

        .calendar .calendar__title .title .button {
            position: absolute;
            top: -7px;
        }

.calendar .calendar--header {
    width: 100%;
    /* border-bottom: solid 1px #ccc; */
}

    .calendar .calendar--header .calendar--header__weekday {
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
        font-weight: bold;
        color: #999999;
    }

.calendar .calendar--body {
    position: relative;
    width: 100%;
    height: 224px;
    /*background:#f2f2f2;*/
    background: #fff;
    margin-bottom: 50px;
    overflow-x: hidden;
    overflow-y: scroll;
}

.calendar--body__line .cell-active .dateCellShip {
    padding-top: 2px;
}

.calendar--body__line .cell-active .dateCellShip img {
    width: 20px;
}

.calendar--body__line .line .dateCellShip img {
    width: 20px;
}

.calendar .calendar--body__line .cell-active .dateCell,
.calendar .calendar--body__line .active .cellShip-active .dateCell {
    /*margin-top: -2px;*/
}

.calendar .calendar--body .calendar--body__line .line {
    float: left;
    vertical-align: middle;
    position: relative;
    text-align: center;
    width: 38px;
    height: 38px;
    margin-top: 0px;
    border-radius: 38px;
}

.calendar--body .calendar--body__line .cell-active,
.calendar--body .calendar--body__line .cellShip-active {
    text-align: center;
    width: 38px;
    height: 38px;
    margin-top: 0px;
    border-radius: 38px;
    vertical-align: middle;
}

.calendar--body .calendar--body__line {
    float: left;
}

.calendar .calendar--body .calendar--body__line .line .date {
    padding: 1px;
    border-radius: 50%;
}

.calendar .calendar--body .calendar--body__line .line .date.deci {
    padding: 1px 2px;
}

.calendar .calendar--body .calendar--body__line .line .date.chosen {
    background: #0E1C56;
    color: #fff;
}

.calendar .calendar--body .calendar--body__line .line span {
    /* padding-top: 2px;
    color: #ccc; */
    font-size: 15px;
}
.calendar .calendar--body .calendar--body__line .line span.signTxt {
    font-size: 9px;
}

.calendar .calendar--body .calendar--body__line .active span {
    /*color: #061556;*/
}

.calendar .calendar--body .calendar--body__line span.priceBottom {
    color: #FF5055;
    font-size: 9px;
    display: block;
}

.calendar .calendar--body .calendar--body__line .active span.priceBottom {
    color: white;
}

.calendar .calendar--body .calendar--body__line .line .priceCell {
    position: absolute;
    bottom: 4px;
    z-index: 1;
    font-family: PingFang-SC-Medium;
    font-size: 10px;
    color: #FFFFFF;
    text-align: center;
}

.calendar .calendar--body .calendar--body__line .line .priceCell .price-content{
    text-align: left;
}

.calendar .calendar--body .calendar--body__line .line .priceCell .price, .calendar .calendar--body .calendar--body__line .line .priceCell .packagePrice {
    font-size: 12px;
    color:#666;
}

.calendar .calendar--body .calendar--body__line .line .priceCell .small-font {
    font-size: 10px;
    color:#666;
}

.calendar .calendar--body .calendar--body__line .line .priceCell .yellow {
    color: #E8B700;
}

.calendar .calendar--body .calendar--body__line .line.shipEvent {
    /*background-color: #4A90E2;
    border-radius:initial;*/
}
.calendar .calendar--body .calendar--body__line .line.shipEvent .small-font,
.calendar .calendar--body .calendar--body__line .line.shipEvent .price{
    
}

.calendar .calendar--body .calendar--body__line .line.shipEvent:hover {
    cursor: pointer;
}
.calendar .calendar--body .calendar--body__line .line.shipEvent.active {
    background-color: #4A90E2;
    border-radius: initial;
    -webkit-border-radius: initial;
    -moz-border-radius: initial;
}
.calendar .calendar--body .calendar--body__line .line.shipEvent.active .cell-active .dateCell .date {
    color:#fff;
}
.calendar .calendar--body .calendar--body__line .line.shipEvent.active .small-font,
.calendar .calendar--body .calendar--body__line .line.shipEvent.active .price,
.calendar .calendar--body .calendar--body__line .line.shipEvent.active .packagePrice{
    color: #fff;
}
.calendar .calendar--body .calendar--body__line .line.shipEvent.active .signTxt{
    background-color:#fff;
    color: #4A90E2 !important;
}
.calendar .calendar--body .calendar--body__line .vacation {
    /* color: #eeeeee; */
}


.calendar .calendar--cell {
    width: 33px;
    height: 24px;
    text-align: center;
    margin-top: 10px;
    color: #ccc;
}

    .calendar .calendar--cell span {
        position: relative;
    }

    .calendar .calendar--cell .dateCell {
        margin-top: 5px;
    }

#calendarModal {
    opacity: 1;
    /*background: rgba(0, 0, 0, 0.2);*/
    /*position:inherit;*/
    position: fixed;
    top: 100px;
}

.calendar__title .title .leftArrow {
    border-left: none;
}

.calendar__title .title .rightArrow {
    border-right: none;
}

#calendarModal .modal-dialog {
    top: 220px;
    width: 100%;
}

.button--closed {
    width: 39px;
    position: absolute;
    top: 0px;
    right: -44px;
    cursor: pointer;
}

.detail_calendar_content .calendar-close {
    height: 31px;
    width: 100%;
    overflow: hidden;
    text-align: right;
}

    .detail_calendar_content .calendar-close img {
        float: right;
        width: 25px;
        margin: 3px 5px;
    }

    .detail_calendar_content .calendar-close span {
        width: 20px;
        height: 20px;
        background: #061556;
        color: #fff;
        border-radius: 20px;
        float: right;
        text-align: center;
        line-height: 20px;
        margin: 3px 5px;
    }

.calendar--body__line .cell-active {
    /*background: #061556;*/
}

.calendar .calendar--body .calendar--body__line
.cell-active .dateCell .date {
    color: #333;
    font-size:15px;
    font-weight:bold;
}

.confirmation-date {
    position: relative;
    width: 100%;
    height: 30px;
    text-align: center;
    margin-top: 30px;
}

.confirmation-date .confirmation-button {
    width: 150px;
    height: 30px;
    text-align: center;
    position: absolute;
    overflow: hidden;
    top: -27px;
    font-size: 14px;
    line-height: 30px;
    left: 63px;
    color: #fff;
    background: #fbc300;
}
/*# sourceMappingURL=calendar_cruise.css.map */


/**** 更多日期新增 ****/
#moreSailDate {
    background-color: #fff !important;
    z-index: 1111112;
    padding-bottom: 0;
    
}
.moreSailDate {
    position: relative;
    height: 100%;
    top: -50px;
}
.moreSailDate-container {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 50px;
}
.moreSailDate-top {
    background-color:#e4e4e4;
}
.moreSailDate-title {
    padding: 15px 20px;
    background-color: #fff;
    overflow: hidden;
    text-align: center;
    position: relative;
}
.moreSailDate-title p {
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #333333;
    letter-spacing: 1px;
    text-align: center;
    margin: 0;
}
.moreSailDate-returnButton {
    position: absolute;
    top: 16px;
    left:20px;
    width: 30px;
    text-align: left;
}
.moreSailDate-returnButton img {
    width: 10px;
}
.moreSailDate .calendar .calendar--cell {
    width:14%;
}
.moreSailDate .calendar .calendar--body {
    overflow-y:hidden;
    margin-bottom:0px;
    height: 488px;
}
.moreSailDate .calendar--body .calendar--body__line {
    width: 100%;
    border-top: 1px solid rgba(204, 204, 204, 0.7);
}

.moreSailDate .calendar--body div.calendar--body__line:last-of-type {
    border-bottom: 1px solid rgba(204, 204, 204, 0.7);
}

.moreSailDate .calendar .calendar--body .calendar--body__line .line {
    width: 14.2%;
    height:80px;
}
.moreSailDate .signTxt {
    width: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
    display: inline-block;
    border-radius: 50%;
    color: #FFFFFF !important;
    background: #FF5055;
}
.moreSailDate-bottom {
    overflow:hidden;
    /* display:none; */
    position: absolute;
    bottom: 0px;
}
.moreSailDate-bottom-l {
    width:250px;
    text-align:left;
    height:50px;
    line-height:50px;
    float: left;
    background-image: linear-gradient(90deg, #4A90E2 21%, #1A92E0 100%);
    font-family: PingFang-SC-Medium;
    font-size: 12px;
    color: #fff;
    letter-spacing: 2px;
    padding-left: 20px;
}

#moreSailDate-bottom-package .moreSailDate-bottom-l {
    width: 187.5px;
    background: #F6F7F8;
    color: #666666;
}


.moreSailDate-bottom-l span.moreSailDate-bottom-price {
    font-size: 18px;
    color: #fff;
    letter-spacing: 0;
}

#moreSailDate-bottom-package .moreSailDate-bottom-l span {
    color: #FF5055;
}

.moreSailDate-bottom-r {
    float:left;
    width:124px;
    text-align:center;
    height: 50px;
    line-height: 50px;
    background-image: linear-gradient(270deg, #FAD961 0%, #FEBC10 100%);
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #454545;
}

#moreSailDate-bottom-package .moreSailDate-bottom-r {
    width: 187.5px;
    font-size: 12px;
    color: #454545;
    letter-spacing: 2px;
}

#moreSailDate-bottom-package .moreSailDate-bottom-r  span {
    font-size:  19px;
    color: #454545;
    font-weight: 500;
}


.popup-more-saildate{
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
}

.popup-more-saildate.modal-out {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
}
</style>